import { render } from "./FilterTree.vue?vue&type=template&id=5bdee062"
import script from "./FilterTree.vue?vue&type=script&lang=js"
export * from "./FilterTree.vue?vue&type=script&lang=js"
script.render = render

export default script